// notificacionInventarioSchema.tsx

import * as yup from 'yup';

export const notificacionInventarioSchema = yup.object({

});
